<div class="row">
  <div class="col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3 components-bg">
    <div class="tab-manual__sections" [(style.margin-top)]="margin">
      <div class="sidebar-header mb-3">
        <h3 class="text-white mb-0 lh-1">Índice</h3>
      </div>
      <ul class="tab-manual__sections--indice">
        <li class="indice-nav" (click)="scrollInToView('introducción')">
          <p class="indice-nav__firts encabezadoind">Introducción:</p>
        </li>
        <li class="indice-nav" (click)="scrollInToView('acceso-al-buscador-jurídico')">
          <p class="indice-nav__second">Acceso al Buscador
            Jurídico.</p>
        </li>
        <li class="indice-nav" (click)="scrollInToView('página-de-inicio')">
          <p class="ml-3 indice-nav__second">Página de inicio.</p>
        </li>
        <li class="indice-nav" (click)="scrollInToView('búsqueda-de-información')">
          <p class="indice-nav__firts skin-color-text">Búsqueda de
            Información:</p>
        </li>
        <li class="indice-nav" (click)="scrollInToView('palabras-clave-o-sintaxis-de-búsqueda')">
          <p class="ml-3 indice-nav__second">Palabras
            clave o sintaxis de búsqueda.</p>
        </li>
        <li class="indice-nav" (click)="scrollInToView('búsqueda-avanzada')">
          <p class="ml-3 indice-nav__second">Búsqueda Avanzada.</p>
        </li>
        <li class="indice-nav" (click)="scrollInToView('herramientas-adicionales-de-búsqueda')">
          <p class="ml-3 indice-nav__second">Herramientas adicionales de búsqueda.</p>
        </li>
        <li class="indice-nav" (click)="scrollInToView('fuentes-de-datos')">
          <p class="indice-nav__firts skin-color-text">Fuentes de Información:</p>
        </li>
        <li class="indice-nav" (click)="scrollInToView('sentencias')">
          <p class="ml-3 indice-nav__second">Sentencias.</p>
        </li>
        <li class="indice-nav" (click)="scrollInToView('tesis')">
          <p class="ml-3 indice-nav__second">Tesis.</p>
        </li>
        <li class="indice-nav" (click)="scrollInToView('votos')">
          <p class="ml-3 indice-nav__second">Votos.</p>
        </li>
        <li class="indice-nav" (click)="scrollInToView('acuerdos-generales-y-otros-documentos-publicados')">
          <p class="ml-3 indice-nav__second">
            Acuerdos.</p>
        </li>
        <li class="indice-nav" (click)="scrollInToView('acervo-bibliotecario')">
          <p class="ml-3 indice-nav__second">Acervo bibliotecario.</p>
        </li>
        <li class="indice-nav" (click)="scrollInToView('versiones-taquigráficas')">
          <p class="ml-3 indice-nav__second">Versiones
            taquigráficas.</p>
        </li>
        <li class="indice-nav" (click)="scrollInToView('ordenamientos')">
          <p class="ml-3 indice-nav__second">Ordenamientos.</p>
        </li>
        <li class="indice-nav" (click)="scrollInToView('casas-cultura-jurídica')">
          <p class="ml-3 indice-nav__second">Casas de la Cultura Jurídica.</p>
        </li>
        <li class="indice-nav" (click)="scrollInToView('corte-constitucional-de-la-república-de-colombia')">
          <p class="ml-3 indice-nav__second">
            Corte Constitucional de la República de Colombia.</p>
        </li>
        <li class="indice-nav" (click)="scrollInToView('tribunal-constitucional-de-chile')">
          <p class="ml-3 indice-nav__second">Tribunal Constitucional de Chile.</p>
        </li>
        <li class="indice-nav" (click)="scrollInToView('corte-suprema-de-justicia-de-la-nación-de-argentina')">
          <p class="ml-3 indice-nav__second">Corte Suprema de Justicia de la Nación de Argentina.</p>
        </li>
        <li class="indice-nav" (click)="scrollInToView('tribunal-constitucional-de-españa')">
          <p class="ml-3 indice-nav__second">Tribunal Constitucional de España.</p>
        </li>
        <li class="indice-nav" (click)="scrollInToView('resoluciones-scjn')">
          <p class="ml-3 indice-nav__second">Resoluciones SCJN.</p>
        </li>
        <li class="indice-nav" (click)="scrollInToView('resoluciones-comite-especializado')">
          <p class="ml-3 indice-nav__second">Resoluciones Comité Especializado.</p>
        </li>
        <li class="indice-nav" (click)="scrollInToView('resoluciones-comite-transparencia')">
          <p class="ml-3 indice-nav__second">Resoluciones Comité Transparencia.</p>
        </li>
        <li class="indice-nav" (click)="scrollInToView('comisión-interamericana-de-derechos-humanos')">
          <p class="ml-3 indice-nav__second">Comisión Interamericana de Derechos Humanos.</p>
        </li>
        <li class="indice-nav" (click)="scrollInToView('corte-europea-de-derechos-humanos')">
          <p class="ml-3 indice-nav__second">Corte Europea de Derechos Humanos.</p>
        </li>
        <li class="indice-nav" (click)="scrollInToView('corte-internacional-de-justicia')">
          <p class="ml-3 indice-nav__second">Corte Internacional de Justicia.</p>
        </li>
        <li class="indice-nav" (click)="scrollInToView('sistema-de-naciones-unidas')">
          <p class="ml-3 indice-nav__second">Sistema de Naciones Unidas.</p>
        </li>
        <li class="indice-nav" (click)="scrollInToView('corte-interamericana-de-derechos-humanos')">
          <p class="ml-3 indice-nav__second">Corte Interamericana de Derechos Humanos.</p>
        </li>
        <!-- <li class="indice-nav" (click)="scrollInToView('tesauro')">
          <p class="indice-nav__firts skin-color-text">Tesauro</p>
        </li>
        -->
        <li class="indice-nav" (click)="scrollInToView('recomendación')">
          <p class="indice-nav__firts skin-color-text">Recomendación</p>
        </li>
        <li class="indice-nav" (click)="scrollInToView('material')">
          <p class="indice-nav__firts skin-color-text">Material para presentación:</p>
        </li>
        <li class="indice-nav" (click)="scrollInToView('generales')">
          <p class="ml-3 indice-nav__second">Generales.</p>
        </li>
        <li class="indice-nav" (click)="scrollInToView('agraria')">
          <p class="ml-3 indice-nav__second">Materia Agraria.</p>
        </li>
        <li class="indice-nav" (click)="scrollInToView('mercantil')">
          <p class="ml-3 indice-nav__second">Competencia económica.</p>
        </li>
      </ul>
    </div>
  </div>
  <div class="col-12 col-sm-12 col-md-8 col-lg-9 col-xl-9 tab-manual__content">
    <!-- <div class="d-flex justify-content-end">
      <a role="link" href="./assets/img/img-manual/UGACJManualDeUsuarioBJ.pdf" target="_blank"
        download="UGACJManualDeUsuarioBJ"
        class="d-flex justify-content-end align-items-center download skin-color-text"><i
          class="material-icons">download</i> Descargar
        manual</a>
    </div>-->
    <h1 class="title mb-0 pb-2" [attr.id]="'introducción'">Guía y manual de usuario</h1>
    <div class="tab-manual__content--bl">
      <h2 class="tab-manual__content--bl-title skin-color-text">Introducción</h2>

      <p> Es el objetivo del Buscador Jurídico mostrar la filosofía innovadora de
        administración y difusión del conocimiento, así como la operación de esta
        plataforma tecnológica que permite acercar al consultante la información
        para su labor jurídica.

      <p>El presente manual muestra de manera detallada las secciones, herramientas y
        funcionamiento del BJ; permite a cualquier usuario, ya sea especialista en derecho
        o no, acceder a una herramienta ágil, accesible y amigable que contiene todos los
        criterios emitidos por el Alto Tribunal y facilita la labor jurídica y jurisdiccional de
        estudiantes e investigadores, por esa razón es importante conocer cada uno de sus
        apartados.
    </div>
    <div class="tab-manual__content--bl" [attr.id]="'acceso-al-buscador-jurídico'">
      <h2 class="tab-manual__content--bl-title skin-color-text">Acceso al Buscador Jurídico</h2>
      <p>Para tener acceso al Buscador Jurídico de la Suprema Corte de Justicia de la
        Nación se realizan las siguientes acciones:
      <ul class="ml-5">
        <li>1. Abra su navegador (Google Chrome, Firefox, Safari, Microsoft
          Edge, etc.).
        </li>
        <li>2. Acceda a la siguiente dirección:
          <a role="link" class="skin-color-text" href="https://bj.scjn.gob.mx" rel="noopener"
            target="_blank">https://bj.scjn.gob.mx</a>
        </li>
      </ul>
      <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3 ">
        <div class="col-12">
          <img class="w-100 imgborde" src="./assets/img/img-manual/UGACJ_Imagen_MBJ_1p.png" alt="Buscador Jurídico">
        </div>
      </div>
    </div>
    <div class="tab-manual__content--bl" [attr.id]="'página-de-inicio'">
      <h3 class="tab-manual__content--bl-subtitle">Página de Inicio</h3>
      <p>
        La página de inicio muestra una serie de apartados de consulta y localización de
        información jurídica, con la finalidad de integrar a través de una sola plataforma la
        mayor cantidad de información que emite la SCJN.
      </p>
      <ul class="ml-5">
        <li><span>1. Recuadro Central de Búsqueda. En este
            apartado te permite realizar consultas sobre el universo de información del
            Buscador Jurídico; al dar clic sobre él puede realizar una búsqueda por
            palabras, frases o sintaxis.</span></li>
        <li><span>2. Fuentes de información. Al acceder al BJ se despliegan diversas
            opciones
            de consulta dentro la SCJN como son: Sentencias, Tesis, Reformas, Votos, Acuerdos,
            Acervo Bibliotecario, Ordenamientos, Versiones Taquigráficas del
            Pleno y Salas, Casas de la Cultura Jurídica y otros fuentes de información como los
            Tribunales y Cortes Constitucionales, la Unidad General de Transparencia y Sistematización
            del Poder Judicial y Organos internacionales
          </span></li>
        <li><span>3. Búsqueda avanzada. Se despliega una serie de recuadros de
            captura para
            realizar una búsqueda más específica de las fuentes de información
            mediante el uso de sintaxis.</span></li>

        <p>También puedes encontrar en parte inferior central, las distintas
          opciones de consulta de las redes sociales de la SCJN; el ícono que
          lleva a la plataforma Tesauro; la guía de uso; Ademas de ingresar a otras
          fuentes de datos sí cuentas con una cuenta de la corte.</p>

        <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
          <div class="col-12">
            <img class="w-100 imgborde" src="./assets/img/img-manual/UGACJ_Imagen_MBJ_2p.png" alt="Página de inicio">
          </div>
        </div>
      </ul>
    </div>
    <div class="tab-manual__content--bl" [attr.id]="'búsqueda-de-información'">
      <h2 class="tab-manual__content--bl-title skin-color-text">Búsqueda de Información</h2>
      <p>Para acceder a la información existen las siguientes opciones en la página de inicio:
      </p>
      <ul class="ml-5">
        <li>1. Palabras clave o sintaxis de búsqueda.</li>
        <li>2. Búsqueda avanzada.</li>
      </ul>
      <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
        <div class="col-12">
          <img class="w-100 imgborde" src="./assets/img/img-manual/img_bj_3p.png" alt="Búsquedas de información">
        </div>
      </div>
    </div>
    <div class="tab-manual__content--bl" [attr.id]="'palabras-clave-o-sintaxis-de-búsqueda'">
      <h3 class="tab-manual__content--bl-subtitle">Palabras Clave o Sintaxis de Búsqueda</h3>
      <p>Para hacer uso de esta opción, se deben escribir términos o frases sobre el recuadro
        central de la página de inicio, o bien hacer uso de la sintaxis de búsqueda mediante
        palabras, conceptos, caracteres, operadores y luego dar clic en el botón "ejecutar”.</p>

      <p>Sobre el recuadro central se encuentra un ícono de ayuda que despliega “ejemplos
        de sintaxis de búsqueda”, en el cual se desglosan sugerencias de cómo realizar
        consultas utilizando palabras clave, caracteres especiales y operadores lógicos o
        booleanos.</p>
      <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
        <div class="col-12">
          <img class="w-100 imgborde" src="./assets/img/img-manual/imag_bj_4p.png"
            alt="Búsqueda por palabra clave o su sintaxis de búsqueda">
        </div>
      </div>
      <p class="pt-4">Si al realizar una búsqueda básica no se encuentran resultados relevantes, se
        recomienda seleccionar alguna fuente de información en el recuadro “Buscar en”
        y/o hacer uso de caracteres especiales:</p>
      <ul class="ml-5">
        <li><span>Las<strong> comillas ("") </strong>se utilizan para encontrar frases
            exactas.</span>
          <p class="ml-3">Ej. "pérdida de patria potestad"</p>
        </li>
        <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
          <div class="col-12">
            <img class="w-100 imgborde" src="./assets/img/img-manual/UGACJ_Imagen_MBJ_6p.png"
              alt="Búsqueda por palabra clave o su sintaxis de búsqueda">
          </div>
        </div>
        <li class="pt-4"><span>El<strong> guion (-) </strong>sirve para excluir alguna
            palabra.</span>
          <p class="ml-3">Ej. -delincuencia</p>
        </li>
        <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
          <div class="col-12">
            <img class="w-100 imgborde" src="./assets/img/img-manual/UGACJ_Imagen_MBJ_7p.png"
              alt="Búsqueda por palabra clave o su sintaxis de búsqueda">
          </div>
        </div>
        <li class="pt-4">
          <span>Los<strong> paréntesis () </strong>se emplean para dar prioridad a un término o frase.</span>
          <p class="ml-3 mb-0">Ej. ("desaparición forzada") OR secuestro</p>
          <p class="ml-3">Ej. ("pueblos indígenas") discriminación</p>
        </li>
        <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
          <div class="col-12">
            <img class="w-100 imgborde" src="./assets/img/img-manual/UGACJ_Imagen_MBJ_8p.png"
              alt="Búsqueda por palabra clave o su sintaxis de búsqueda">
          </div>
        </div>
        <li class="pt-4"><span>El<strong> asterisco (*) </strong>sirve para completar palabras o
            frases. Puede ser usado como prefijo, infijo, sufijo.</span>
          <p class="ml-3 mb-0">Ej. *echo (derecho, desecho, hecho…)</p>
          <p class="ml-3 mb-0">Ej. pr*tos (propuestos, preceptos, procedimientos…)</p>
          <p class="ml-3">Ej. micro* (microbiología, microsistema, micronegocio…)</p>
        </li>
        <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
          <div class="col-12">
            <img class="w-100 imgborde" src="./assets/img/img-manual/UGACJ_Imagen_MBJ_9p.png"
              alt="Búsqueda por palabra clave o su sintaxis de búsqueda">
          </div>
        </div>
        <li class="pt-4"><span>La<strong> virgulilla (~) </strong>para incluir palabras similares,
            o si se escribe un
            número después de este signo, realiza una búsqueda de términos con la condición de que las
            palabras o frases se encuentran dentro de un rango de
            distancia una de otra.</span>
          <p class="ml-3 mb-0">Ej. mubying~ (correcto: mobbing)</p>
          <p class="ml-3">Ej. consanguineidad~ (correcto: consanguinidad)</p>
        </li>
        <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
          <div class="col-12">
            <img class="w-100 imgborde" src="./assets/img/img-manual/UGACJ_Imagen_MBJ_10p.png"
              alt="Búsqueda por palabra clave o su sintaxis de búsqueda">
          </div>
        </div>
        <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
          <div class="col-12">
            <img class="w-100 imgborde" src="./assets/img/img-manual/UGACJ_Imagen_MBJ_11p.png"
              alt="Búsqueda por palabra clave o su sintaxis de búsqueda">
          </div>
        </div>
      </ul>
      <p>Asimismo, se pueden utilizar operadores lógicos o booleanos:</p>
      <ul class="ml-5">
        <li><span><strong>Operador "AND"</strong>para recuperar la información que
            incluya todos los términos o frases.</span>
          <p class="ml-3">Ej. "desaparición forzada" AND secuestro AND "delincuencia organizada"</p>
        </li>
        <div class="d-flexp-2 psm-3 plg-3 pxl-5 pmd-3">
          <div class="col-12">
            <img class="w-100 imgborde" src="./assets/img/img-manual/UGACJ_Imagen_MBJ_12p.png"
              alt="Búsqueda por palabra clave o su sintaxis de búsqueda">
          </div>
        </div>
        <li class="pt-4"><span><strong>Operador "OR" </strong>para rescatar documentos que tengan
            cualquiera de las palabras o conceptos.</span>
          <p class="ml-3">Ej. estupro OR "abuso sexual a menores"</p>
        </li>
        <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
          <div class="col-12">
            <img class="w-100 imgborde" src="./assets/img/img-manual/UGACJ_Imagen_MBJ_13p.png"
              alt="Búsqueda por palabra clave o su sintaxis de búsqueda">
          </div>
        </div>
        <li class="pt-4"><span><strong>Operador "NOT" </strong>para recuperar las referencias en
            las que se omitan los términos o frases que se escriben después de éste.</span>
          <p class="ml-3">Ej. NOT (delincuencia)</p>
        </li>
        <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
          <div class="col-12">
            <img class="w-100 imgborde" src="./assets/img/img-manual/UGACJ_Imagen_MBJ_14p.png"
              alt="Búsqueda por palabra clave o su sintaxis de búsqueda">
          </div>
        </div>
      </ul>
      <p class="pt-4">El Buscador Jurídico está diseñado para soportar desde consultas sencillas hasta
        consultas más complejas haciendo uso de combinaciones de palabras clave,
        caracteres especiales y operadores lógicos o booleanos:</p>
      <ul class="ml-5">
        <li><span><strong>Operadores combinados </strong> para hacer consultas usando
            operadores lógicos
            y demás sintaxis de búsqueda.</span>
          <p class="ml-3 mb-0">Ej. "doble nacionalidad" AND (privilegios) NOT (internacional)</p>
          <p class="ml-3">Ej. ("desaparición forzada" OR secuestro) AND "delincuencia organizada"</p>
        </li>
      </ul>
      <p>Además, el BJ no hace distinción en el uso de mayúsculas y minúsculas; sin
        importar la manera en la que se escriba, se obtendrá el mismo resultado. </p>
    </div>
    <div class="tab-manual__content--bl" [attr.id]="'búsqueda-avanzada'">
      <h3 class="tab-manual__content--bl-subtitle">Búsqueda Avanzada</h3>
      <p>Al dar clic en esta opción se visualizan una serie de recuadros de captura que
        permiten realizar una búsqueda más específica de la información, los cuales
        permiten elegir la fuente de información, así como escribir palabras clave, frase
        exacta, palabras que debe o no contener, palabras próximas y el número de
        proximidad entre palabras. La sintaxis de búsqueda se estará mostrando en el
        recuadro gris de esta sección.
      <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
        <div class="col-12">
          <img class="w-100 imgborde" src="./assets/img/img-manual/UGACJ_Imagen_MBJ_18p.png" alt="Búsqueda avanzada">
        </div>
      </div>
    </div>
    <div class="tab-manual__content--bl" [attr.id]="'herramientas-adicionales-de-búsqueda'">
      <h3 class="tab-manual__content--bl-subtitle">Herramientas adicionales de búsqueda</h3>
      <p>El Buscador Jurídico cuenta con herramientas adicionales que facilitan la consulta
        de información tanto en la página de resultados como en la de detalle de un
        documento.
      <p>Al escoger una fuente de información en el recuadro “Buscar en”, se mostrará una
        barra de selección en la que se podrá elegir algún campo de la fuente y enseguida
        escribir palabras o frases que se desean consultar en los documentos en el recuadro
        de captura “Buscar en resultados”.
      <p>Asimismo, se encuentran dos opciones de selección en las que se pueden elegir la
        cantidad de resultados por página y el número de caracteres visibles en el recuadro
        “Ver extractos de documento” que aparece en la parte inferior de cada resultado.
      <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
        <div class="col-12">
          <img class="w-100 imgborde" src="./assets/img/img-manual/UGACJ_Imagen_MBJ_20p.png" alt="Búsqueda avanzada">
        </div>
      </div>
      <p class="pt-4">Al ingresar al detalle de un documento se visualiza una barra de herramientas en
        donde se pueden realizar las siguientes funciones:</p>
      <ul class="ml-5">
        <li><span>Regresar a la página de inicio.</span></li>
        <li><span>Regresar a la búsqueda.</span></li>
        <li><span>Regresar al documento anterior.</span></li>
        <li><span>Avanzar al siguiente documento.</span></li>
        <li><span>Copiar todo el documento.</span></li>
        <li><span>Imprimir documento.</span></li>
      </ul>
      <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
        <div class="col-12">
          <img class="w-100 imgborde" src="./assets/img/img-manual/UGACJ_Imagen_MBJ_21p.png" alt="Búsqueda avanzada">
        </div>
      </div>
    </div>
    <div class="tab-manual__content--bl" [attr.id]="'fuentes-de-datos'">
      <h2 class="tab-manual__content--bl-title skin-color-text">Fuentes de Información</h2>
      <p>
        Para acceder a alguna fuente de información, se da clic en la que se desea consultar
        y lo que desea buscar en ella. Las fuentes de información que se pueden consultar en los
        diferentes apartados de la SCJN, Tribunales y Cortes Constitucionales,Organos internacionales y
        la Unidad General de Transparencia y Sistematización del Poder Judicial.
      </p>
      <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
        <div class="col-12">
          <img class="w-100 imgborde" src="./assets/img/img-manual/UGACJ_Imagen_MBJ_22p.png"
            alt="Fuentes de Información">
        </div>
      </div>
    </div>
    <div class="tab-manual__content--bl" [attr.id]="'sentencias'">
      <h3 class="tab-manual__content--bl-subtitle">Sentencias</h3>
      <p>En esta fuente de información se cuentan con diversos criterios que
        permiten realizar búsquedas específicas:</p>
      <ul class="ml-5">
        <li> Tipo de Asunto</li>
        <li> Órgano de radicación</li>
        <li> Ponente</li>
        <li> Año</li>
      </ul>
      <p>Además, existe la posibilidad de filtrar por periodo personalizado; en la parte inferior
        de la sección de criterios de búsqueda se visualiza el filtro de "Fecha de
        resolución", al dar clic en el ícono se muestra un calendario en el cual se puede
        seleccionar un rango de fecha.</p>

      <p>Al aplicar alguno de estos filtros de consulta, el sistema acotará el total de
        resultados, mostrando únicamente aquellos que cuenten con los criterios de
        búsqueda indicados por el usuario.</p>
      <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
        <div class="col-12">
          <img class="w-100 imgborde" src="./assets/img/img-manual/img_bj_24p.png" alt="Consulta de sentencias">
        </div>
      </div>

      <p class="pt-4">Se puede consultar y descargar el documento origen de una Sentencia desde la
        página de resultados a través del ícono de Word que se muestra al lado de cada
        resultado.</p>
      <p>Al abrir una Sentencia, se visualiza en la parte superior del texto la opción
        "Consulte el documento origen" en formato Word al dar clic se descarga, así como unas pestañas
        que permiten visualizar información complementaria.</p>
      <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
        <div class="col-12">
          <img class="w-100 imgborde" src="./assets/img/img-manual/UGACJ_Imagen_MBJ_25p.png"
            alt="Ficha técnica sentencia">
        </div>
      </div>
      <ul class="ml-5">
        <li class="pt-4">Ficha técnica. Se muestran los datos principales de la Sentencia como el
          número de expediente, tipo de asunto, ministro y tema correspondiente;
          además contiene un botón "Ir a Sentencias y datos de expedientes" que redirige
          al expediente dentro del sitio web de la SCJN.
          <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3 pt-4">
            <div class="col-12">
              <img class="w-100 imgborde" src="./assets/img/img-manual/UGACJ_Imagen_MBJ_26p.png"
                alt="Ficha técnica sentencia">
            </div>
          </div>
        </li>
        <li class="pt-4">Documentos sugeridos. Se muestran aquellos documentos que se
          encuentran relacionados con el contenido de la Sentencia que se está
          consultando.
          <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3 pt-4">
            <div class="col-12">
              <img class="w-100 imgborde" src="./assets/img/img-manual/UGACJ_Imagen_MBJ_27p.png"
                alt="Documentos sugeridos">
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="tab-manual__content--bl" [attr.id]="'tesis'">
      <h3 class="tab-manual__content--bl-subtitle">Tesis</h3>
      <p>
        Es posible consultar los pronunciamientos aplicables y vigentes publicados por la
        Suprema Corte de Justicia de la Nación, los Plenos de Circuito y los Tribunales
        Colegiados de Circuito, simplemente con dar clic en Tesis.</p>
      <p>En esta fuente de información se cuentan con diversos criterios que permiten
        realizar búsquedas específicas:</p>
      <ul class="ml-5">
        <li> Tipo</li>
        <li> Formas de integración</li>
        <li> Época</li>
        <li> Materia</li>
        <li> Fuente</li>
        <li> Instancia</li>
        <li> Año</li>
        <li> Línea Jurisprudencial</li>
        <li> Órgano Jurisdiccional</li>
      </ul>
      <p>Además, existe la posibilidad de filtrar por periodo personalizado; en la parte inferior
        de la sección de criterios de búsqueda se visualiza el filtro de "Fecha de
        resolución", al dar clic en el ícono se muestra un calendario en el cual se puede
        seleccionar un rango de fecha.</p>

      <p>Al aplicar alguno de estos filtros de consulta, el sistema acotará el total de
        resultados, mostrando únicamente aquellos que cuenten con los criterios de
        búsqueda indicados por el usuario.</p>
      <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
        <div class="col-12">
          <img class="w-100 imgborde" src="./assets/img/img-manual/img_bj_36p.png" alt="Consulta tesis">
        </div>
      </div>

      <p class="pt-5">
        Al abrir una Tesis, se visualiza en la parte superior del texto una pestaña que permite
        visualizar documentos sugeridos, la cual muestra aquellos documentos que se
        encuentran relacionados con el contenido de la Tesis.</p>
      <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
        <div class="col-12">
          <img class="w-100 imgborde" src="./assets/img/img-manual/UGACJ_Imagen_MBJ_37p.png" alt="Contenido tesis">
        </div>
      </div>
    </div>
    <div class="tab-manual__content--bl" [attr.id]="'votos'">
      <h3 class="tab-manual__content--bl-subtitle">Votos</h3>
      <p>Es posible consultar las posturas singulares o conjuntas de Ministras y Ministros,
        así como de Magistradas y Magistrados respecto a las consideraciones o sentidos
        en que se resuelve un asunto, simplemente con dar clic en Votos.</p>
      <p>En esta fuente de información se cuentan con diversos criterios que permiten
        realizar búsquedas específicas:
      </p>
      <ul class="ml-5">
        <li>Instancia</li>
        <li>Órgano Jurisdiccional</li>
        <li>Época</li>
      </ul>
      <p>Además, existe la posibilidad de filtrar por periodo personalizado; en la parte inferior
        de la sección de criterios de búsqueda se visualiza el filtro de "Fecha de
        publicación", al dar clic en el ícono se muestra un calendario en el cual se puede
        seleccionar un rango de fecha.</p>
      <p>Al aplicar alguno de estos filtros de consulta, el sistema acotará el total de
        resultados, mostrando únicamente aquellos que cuenten con los criterios de
        búsqueda indicados por el usuario.</p>
      <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
        <div class="col-12">
          <img class="w-100 imgborde" src="./assets/img/img-manual/img_bj_41p.png" alt="Consulta votos">
        </div>
      </div>
    </div>
    <div class="tab-manual__content--bl" [attr.id]="'acuerdos-generales-y-otros-documentos-publicados'">
      <h3 class="tab-manual__content--bl-subtitle">Acuerdos</h3>
      <p>Es posible consultar acuerdos y demás instrumentos normativos e
        informativos jurídico-administrativos emitidos por la Presidencia de la Suprema
        Corte de Justicia de la Nación, Plenos y/o Salas, Comisiones o Comités de la SCJN
        de manera conjunta con el Consejo de la Judicatura Federal y/o el Tribunal Electoral
        del Poder Judicial de la Federación, a través de los cuales establecen regulaciones o información de
        importancia para el Poder Judicial de la Federación en diversos
        segmentos, simplemente con dar clic en Acuerdos.</p>
      <p>En esta fuente de información se cuentan con diversos criterios que permiten
        realizar búsquedas específicas:</p>
      <ul class="ml-5">
        <li> Instancia</li>
        <li> Época</li>
        <li> Fuente</li>
      </ul>
      <p>Además, existe la posibilidad de filtrar por periodo personalizado; en la parte inferior
        de la sección de criterios de búsqueda se visualiza el filtro de "Fecha de
        publicación", al dar clic en el ícono se muestra un calendario en el cual se puede
        seleccionar un rango de fecha.</p>

      <p>Al aplicar alguno de estos filtros de consulta, el sistema acotará el total de
        resultados, mostrando únicamente aquellos que cuenten con los criterios de
        búsqueda indicados por el usuario.</p>
      <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
        <div class="col-12">
          <img class="w-100 imgborde" src="./assets/img/img-manual/img_bj_43p.png"
            alt="Consulta acuerdos generales y otros documentos publicados">
        </div>
      </div>
    </div>
    <div class="tab-manual__content--bl" [attr.id]="'acervo-bibliotecario'">
      <h3 class="tab-manual__content--bl-subtitle">Acervo Bibliotecario</h3>
      <p>Es posible consultar la colección bibliohemerográfica de la SCJN, compuesta por
        libros, revistas, periódicos y demás material digital, simplemente con dar clic en
        Acervo bibliotecario.</p>

      <p>En esta fuente de información se cuentan con diversos criterios que permiten
        realizar búsquedas específicas:</p>
      <ul class="ml-5">
        <li> Colección</li>
        <li> Año</li>
        <li> Contenido del enlace </li>
      </ul>

      <p>Al aplicar alguno de estos filtros de consulta, el sistema acotará el total de
        resultados, mostrando únicamente aquellos que cuenten con los criterios de
        búsqueda indicados por el usuario.</p>
      <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
        <div class="col-12">
          <img class="w-100 imgborde" src="./assets/img/img-manual/UGACJ_Imagen_MBJ_49p.png"
            alt="Consulta acervo bibliotecario">
        </div>
      </div>

      <p class="pt-4">Los resultados contienen una lista de temas, se puede consultar más material del
        acervo bibliotecario al dar clic sobre uno de ellos. También se visualiza el resumen
        de algunos resultados, éste aparecerá con un botón de "Ver extractos del documento", el cual desglosará
        toda la sinopsis del contenido bibliográfico.</p>
    </div>
    <div class="tab-manual__content--bl" [attr.id]="'versiones-taquigráficas'">
      <h3 class="tab-manual__content--bl-subtitle">Versiones Taquigráficas</h3>
      <p>Es posible consultar las transcripciones taquigráficas de las sesiones públicas
        ordinarias del Pleno y Salas de la SCJN, simplemente con dar clic en Versiones
        taquigráficas.</p>
      <p>En esta fuente de información se cuentan con diversos criterios que permiten
        realizar búsquedas específicas:</p>
      <ul class="ml-5">
        <li> Año</li>
        <li> Instancia</li>
      </ul>
      <p>Además, existe la posibilidad de filtrar por periodo personalizado; en la parte inferior
        de la sección de criterios de búsqueda se visualiza el filtro de "Periodo de fecha de
        sesión", al dar clic en el ícono se muestra un calendario en el cual se puede
        seleccionar un rango de fecha.</p>

      <p>Al aplicar alguno de estos filtros de consulta, el sistema acotará el total de
        resultados, mostrando únicamente aquellos que cuenten con los criterios de
        búsqueda indicados por el usuario.</p>
      <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
        <div class="col-12">
          <img class="w-100 imgborde" src="./assets/img/img-manual/UGACJ_Imagen_MBJ_52p.png"
            alt="Consulta versiones taquigráficas">
        </div>
      </div>

      <p class="pt-4">Al abrir una versión taquigráfica se visualiza el texto de la versión como el video
        correspondiente de la sesión si se trata del Pleno; además algunas versiones tienen
        la pestaña de ficha técnica.</p>
      <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
        <div class="col-12">
          <img class="w-100 imgborde" src="./assets/img/img-manual/UGACJ_Imagen_MBJ_53p.png"
            alt="Contenido versiones taquigráficas">
        </div>
      </div>
    </div>
    <div class="tab-manual__content--bl" [attr.id]="'ordenamientos'">
      <h3 class="tab-manual__content--bl-subtitle">Ordenamientos</h3>
      <p>Las normas que rigen la organización legal de un determinado lugar y época pueden
        ser consultadas simplemente con dar clic en Ordenamientos.</p>
      <p>En esta fuente de información se cuentan con diversos criterios que permiten
        realizar búsquedas específicas:</p>
      <ul class="ml-5">
        <li> Categoría</li>
        <li> Vigencia</li>
        <li> Entidad federativa</li>
        <li> Municipio</li>
      </ul>
      <p>Además, existe la posibilidad de filtrar por periodo personalizado; en la parte inferior
        de la sección de criterios de búsqueda se visualiza el filtro de "Fecha de
        actualización", al dar clic en el ícono se muestra un calendario en el cual se puede
        seleccionar un rango de fecha.</p>

      <p>Al aplicar alguno de estos filtros de consulta, el sistema acotará el total de
        resultados, mostrando únicamente aquellos que cuenten con los criterios de
        búsqueda indicados por el usuario.</p>
      <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
        <div class="col-12">
          <img class="w-100 imgborde" src="./assets/img/img-manual/img_bj_45p.png" alt="Consulta ordenamientos">
        </div>
      </div>
      <p class="pt-4">
        Al dar clic en el encabezado, encontrará el conjunto de reformas con su respectiva barra
        de visualización y descarga, las cuales pueden contener las siguientes opciones:
      </p>
      <ul class="ml-5">
        <li> Extracto</li>
        <li> Artículos</li>
        <li> Reforma</li>
        <li> Texto completo: descarga el archivo origen del texto</li>
      </ul>
      <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
        <div class="col-12">
          <img class="w-100 imgborde" src="./assets/img/img-manual/UGACJ_Imagen_MBJ_46p.png"
            alt="Contenido ordenamiento">
        </div>
      </div>
    </div>
    <div class="tab-manual__content--bl" [attr.id]="'casas-cultura-jurídica'">
      <h3 class="tab-manual__content--bl-subtitle">Casas de la Cultura Jurídica</h3>
      <p>Es posible consultar sesiones de diversos cursos que se han impartido,
        simplemente con dar clic en Casas de la Cultura Jurídica.</p>
      <p>En esta fuente de información se cuentan con diversos criterios que permiten
        realizar búsquedas específicas:</p>
      <ul class="ml-5">
        <li> Curso</li>
        <li> Tipo de curso</li>
        <li> Módulo</li>
        <li> Sesión</li>
        <li> Disertante</li>
      </ul>

      <p>Además, existe la posibilidad de filtrar por periodo personalizado; en la parte inferior
        de la sección de criterios de búsqueda se visualiza el filtro de "periodo de fecha de
        sesión", al dar clic en el ícono se muestra un calendario en el cual se puede
        seleccionar un rango de fecha.</p>

      <p>Al aplicar alguno de estos filtros de consulta, el sistema acotará el total de
        resultados, mostrando únicamente aquellos que cuenten con los criterios de
        búsqueda indicados por el usuario.</p>
      <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
        <div class="col-12">
          <img class="w-100 imgborde" src="./assets/img/img-manual/UGACJ_Imagen_MBJ_55p.png"
            alt="Consulta versiones taquigráficas">
        </div>
      </div>

      <p class="pt-4">Al abrir un resultado encontrará la lista del contenido de la sesión del curso; al
        seleccionar un tema, la plataforma reproduce el video desde donde están
        abordando la temática seleccionada. También se muestra el video correspondiente
        de la sesión; la pestaña de material de apoyo con enlaces a casos, obras y demás
        referencias, y la pestaña de ficha técnica.</p>
      <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
        <div class="col-12">
          <img class="w-100 imgborde" src="./assets/img/img-manual/UGACJ_Imagen_MBJ_56p.png"
            alt="Contenido versiones taquigráficas">
        </div>
      </div>
    </div>
    <div class="tab-manual__content--bl" [attr.id]="'corte-constitucional-de-la-república-de-colombia'">
      <h3 class="tab-manual__content--bl-subtitle">Corte Constitucional de la Républica de Colombia</h3>
      <p>Para acceder a los documentos de la institución de la rama judicial del poder público
        que tiene como fin salvaguardar la integridad y supremacía de la constitución en
        Colombia, se da clic en la Corte Constitucional de la República de Colombia.</p>
      <p>En esta fuente de información se cuentan con diversos criterios que permiten
        realizar búsquedas específicas:</p>
      <ul class="ml-5">
        <li>Proceso</li>
        <li>Año</li>
      </ul>

      <p>Al aplicar este filtro de consulta, el sistema acotará el total de resultados, mostrando
        únicamente aquellos que cuenten con los criterios de búsqueda indicados por el
        usuario.</p>
      <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
        <div class="col-12">
          <img class="w-100 imgborde" src="./assets/img/img-manual/UGACJ_Imagen_MBJ_79p.png"
            alt="Contenido contitucional de la républica de colombia">
        </div>
      </div>

      <p class="pt-4">Al dar clic en algún documento, se abre el archivo en el sitio web de la Corte
        Constitucional de la República de Colombia.</p>
      <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
        <div class="col-12">
          <img class="w-100 imgborde" src="./assets/img/img-manual/UGACJ_Imagen_MBJ_80p.png"
            alt="Contenido contitucional de la républica de colombia">
        </div>
      </div>
    </div>
    <div class="tab-manual__content--bl" [attr.id]="'tribunal-constitucional-de-chile'">
      <h3 class="tab-manual__content--bl-subtitle">Tribunal Constitucional de Chile</h3>
      <p>Para acceder a los documentos del órgano jurisdiccional que tiene como función
        principal el ejercer el control de constitucionalidad de las leyes en Chile, se da clic
        en el Tribunal Constitucional de Chile.</p>
      <p class="pt-4">En esta fuente de información se cuentan con diversos criterios que permiten
        realizar búsquedas específicas:</p>
      <ul class="ml-5">
        <li> Año</li>
        <li> Sala </li>
      </ul>

      <p>Al aplicar este filtro de consulta, el sistema acotará el total de resultados, mostrando
        únicamente aquellos que cuenten con los criterios de búsqueda indicados por el
        usuario.</p>
      <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
        <div class="col-12">
          <img class="w-100 imgborde" src="./assets/img/img-manual/img_bj_82p.png"
            alt="Consulta tribunal constitucional de chile">
        </div>
      </div>

      <p class="pt-4">Al ingresar al contenido del Tribunal Constitucional de Chile, se visualiza el
        documento en su versión impresa digitalizada.</p>
      <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
        <div class="col-12">
          <img class="w-100 imgborde" src="./assets/img/img-manual/UGACJ_Imagen_MBJ_83p.png"
            alt="Contenido tribunal constitucional de chile">
        </div>
      </div>
    </div>
    <div class="tab-manual__content--bl" [attr.id]="'corte-suprema-de-justicia-de-la-nación-de-argentina'">
      <h3 class="tab-manual__content--bl-subtitle">Corte Suprema de Justicia de la Nacion de Argentina</h3>
      <p>Para acceder a los documentos del máximo tribunal judicial de Argentina, se da clic
        en la Corte Suprema de Justicia de la Nación de Argentina.</p>
      <p>En esta fuente de información se cuentan con diversos criterios que permiten
        realizar búsquedas específicas:</p>
      <ul class="ml-5">
        <li>Año</li>
      </ul>

      <p>Al aplicar este filtro de consulta, el sistema acotará el total de resultados, mostrando
        únicamente aquellos que cuenten con los criterios de búsqueda indicados por el
        usuario.</p>
      <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
        <div class="col-12">
          <img class="w-100 imgborde" src="./assets/img/img-manual/UGACJ_Imagen_MBJ_85p.png"
            alt="Contenido corte suprema de justicia de la nación de argentina">
        </div>
      </div>

      <p class="pt-4">Al ingresar al contenido de la Corte Suprema de Justicia de la Nación de Argentina,
        se visualiza el documento en su versión impresa digitalizada.</p>
      <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
        <div class="col-12">
          <img class="w-100 imgborde" src="./assets/img/img-manual/UGACJ_Imagen_MBJ_86p.png"
            alt="Contenido corte suprema de justicia de la nación de argentina">
        </div>
      </div>
    </div>
    <div class="tab-manual__content--bl" [attr.id]="'tribunal-constitucional-de-españa'">
      <h3 class="tab-manual__content--bl-subtitle">Tribunal Constitucional de España</h3>
      <p>Para acceder a los documentos del órgano jurisdiccional que tiene como función
        principal el ejercer el control de constitucionalidad de las leyes en España, se da clic
        en el Tribunal Constitucional de España.</p>
      <p>En esta fuente de información se cuentan con diversos criterios que permiten
        realizar búsquedas específicas:</p>
      <ul class="ml-5">
        <li>Competencia</li>
      </ul>
      <p>Al aplicar este filtro de consulta, el sistema acotará el total de resultados, mostrando
        únicamente aquellos que cuenten con los criterios de búsqueda indicados por el
        usuario.</p>
      <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
        <div class="col-12">
          <img class="w-100 imgborde" src="./assets/img/img-manual/UGACJ_Imagen_MBJ_76p.png"
            alt="Contenido tribunal constitucional de españa">
        </div>
      </div>
      <p class="pt-4">Al ingresar al contenido del Tribunal Constitucional de España, se
        visualizan dos pestañas:</p>
      <ul class="ml-5">
        <li>Contenido.
        </li>
        <li> Ficha técnica.
        </li>
      </ul>
      <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
        <div class="col-12">
          <img class="w-100 imgborde" src="./assets/img/img-manual/UGACJ_Imagen_MBJ_77p.png"
            alt="Contenido tribunal constitucional de españa">
        </div>
      </div>
    </div>
    <div class="tab-manual__content--bl" [attr.id]="'resoluciones-scjn'">
      <h3 class="tab-manual__content--bl-subtitle">Resoluciones SCJN</h3>
      <p>Es posible consultar las resoluciones de los diferentes temas y sus Ponentes en Pleno, Primera Sala
        y Segunda Sala de la Suprema Corte de Justicia de la Nación, simplemente con dar
        clic en Resoluciones SCJN.</p>

      <p>Existe la posibilidad de filtrar por periodo personalizado; en la parte inferior
        de la sección de criterios de búsqueda se visualiza el filtro de "Fecha de
        resolución, al dar clic en el ícono se muestra un calendario en el cual se puede
        seleccionar un rango de fecha.</p>
      <p>Al aplicar alguno de estos filtros de consulta, el sistema acotará el total de
        resultados, mostrando únicamente aquellos que cuenten con el criterio de
        búsqueda indicados por el usuario.</p>
      <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
        <div class="col-12">
          <img class="w-100 imgborde" src="./assets/img/img-manual/UGACJ_Imagen_resoluciones_MBJ_41p.png"
            alt="Resoluciones SCJN">
        </div>
      </div>
    </div>
    <div class="tab-manual__content--bl" [attr.id]="'resoluciones-comite-especializado'">
      <h3 class="tab-manual__content--bl-subtitle">Resoluciones Comité Especializado</h3>
      <p>Es posible consultar las Resoluciones de Comité Especializado de la Unidad General de Transparencia y
        Sistematización de la Información Judicial, simplemente con dar
        clic en Resoluciones Comité Especializado.</p>

      <p>Existe la posibilidad de filtrar por periodo personalizado; en la parte inferior
        de la sección de criterios de búsqueda se visualiza el filtro de "Periodo de fecha de
        resolución", al dar clic en el ícono se muestra un calendario en el cual se puede
        seleccionar un rango de fecha.</p>
      <p>Al aplicar alguno de estos filtros de consulta, el sistema acotará el total de
        resultados, mostrando únicamente aquellos que cuenten con el criterio de
        búsqueda indicados por el usuario.</p>
      <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
        <div class="col-12">
          <img class="w-100 imgborde" src="./assets/img/img-manual/UGACJ_Imagen_rce_MBJ_41p.png"
            alt="Resoluciones Comité Especializado">
        </div>
      </div>
    </div>
    <div class="tab-manual__content--bl" [attr.id]="'resoluciones-comite-transparencia'">
      <h3 class="tab-manual__content--bl-subtitle">Resoluciones Comité Transparencia</h3>
      <p>Es posible consultar las Resoluciones de Comité Transparencia de la Unidad General de Transparencia y
        Sistematización de la Información Judicial, simplemente con dar
        clic en Resoluciones Comité Transparencia</p>

      <p>Existe la posibilidad de filtrar por periodo personalizado; en la parte inferior
        de la sección de criterios de búsqueda se visualiza el filtro de "Fecha de
        resolución", al dar clic en el ícono se muestra un calendario en el cual se puede
        seleccionar un rango de fecha.</p>
      <p>Al aplicar alguno de estos filtros de consulta, el sistema acotará el total de
        resultados, mostrando únicamente aquellos que cuenten con el criterio de
        búsqueda indicados por el usuario.</p>
      <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
        <div class="col-12">
          <img class="w-100 imgborde" src="./assets/img/img-manual/UGACJ_Imagen_rct_MBJ_41p.png"
            alt="Resoluciones Comité Especializado">
        </div>
      </div>
    </div>
    <div class="tab-manual__content--bl" [attr.id]="'comisión-interamericana-de-derechos-humanos'">
      <h3 class="tab-manual__content--bl-subtitle">Comisión Interamericana de Derechos Humanos</h3>
      <p>Para acceder a los documentos del órgano principal y autónomo de la Organización
        de los Estados Americanos (OEA) encargado de la promoción y protección de los
        derechos humanos en el continente americano, se da clic en la Comisión
        Interamericana de Derechos Humanos.</p>
      <p>En esta fuente de información se cuentan con diversos criterios que permiten
        realizar búsquedas específicas:</p>
      <ul class="ml-5">
        <li>País</li>
        <li>Tipo</li>
        <li>Año </li>
      </ul>
      <p>Al aplicar alguno de estos filtros de consulta, el sistema acotará el total de
        resultados, mostrando únicamente aquellos que cuenten con los criterios de
        búsqueda indicados por el usuario.</p>
      <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
        <div class="col-12">
          <img class="w-100 imgborde" src="./assets/img/img-manual/UGACJ_Imagen_MBJ_67p.png"
            alt="Conteido comisión interamericana de derechos humanos">
        </div>
      </div>
      <p class="pt-2">Al dar clic sobre un resultado, se abre el documento</p>
    </div>
    <div class="tab-manual__content--bl" [attr.id]="'corte-europea-de-derechos-humanos'">
      <h3 class="tab-manual__content--bl-subtitle">Corte Europea de Derechos Humanos</h3>
      <p>Para acceder a los documentos del tribunal que supervisa que se cumplan con los
        tratados europeos sobre derechos humanos y sus protocolos adicionales, se da clic
        en la Corte Europea de Derechos Humanos.</p>
      <p>En esta fuente de información se cuentan con diversos criterios que permiten
        realizar búsquedas específicas:</p>
      <ul class="ml-5">
        <li>Branch</li>
      </ul>
      <p>Al aplicar este filtro de consulta, el sistema acotará el total de resultados, mostrando
        únicamente aquellos que cuenten con los criterios de búsqueda indicados por el
        usuario.</p>
      <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
        <div class="col-12">
          <img class="w-100 imgborde" src="./assets/img/img-manual/UGACJ_Imagen_MBJ_69p.png"
            alt="Contenido corte Europea de derechos humanos">
        </div>
      </div>
    </div>
    <div class="tab-manual__content--bl" [attr.id]="'corte-internacional-de-justicia'">
      <h3 class="tab-manual__content--bl-subtitle">Corte Internacional de Justicia</h3>
      <p>Para acceder a los documentos del principal órgano judicial de la Organización de
        Naciones Unidas, se da clic en la Corte Internacional de Justicia.</p>
      <p>En esta fuente de información se cuentan con diversos criterios que permiten
        realizar búsquedas específicas:</p>
      <ul class="ml-5">
        <li>Año </li>
      </ul>
      <p>Al aplicar este filtro de consulta, el sistema acotará el total de resultados, mostrando
        únicamente aquellos que cuenten con los criterios de búsqueda indicados por el
        usuario.</p>
      <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
        <div class="col-12">
          <img class="w-100 imgborde" src="./assets/img/img-manual/UGACJ_Imagen_MBJ_72p.png"
            alt="Contenido corte internacional de justicia">
        </div>
      </div>
    </div>
    <div class="tab-manual__content--bl" [attr.id]="'sistema-de-naciones-unidas'">
      <h3 class="tab-manual__content--bl-subtitle">Sistema de Naciones Unidas</h3>
      <p>Para realizar búsquedas especializadas de información emitida por las diferentes
        organizaciones internacionales que protegen los derechos humanos, se da clic en
        el Sistema de Naciones Unidas.</p>
      <p>En esta fuente de información se cuentan con diversos criterios que permiten
        realizar búsquedas específicas:</p>
      <ul class="ml-5">
        <li> Procedimientos especiales</li>
        <li> Tratados Internacionales de Derechos Humanos</li>
        <li> Comité</li>
        <li> Casos y opiniones</li>
      </ul>
      <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
        <div class="col-12">
          <img class="w-100 imgborde" src="./assets/img/img-manual/UGACJ_Imagen_MBJ_61p.png"
            alt="Contenido tratados internacionales de derechos humanos">
        </div>
      </div>
    </div>
    <div class="tab-manual__content--bl" [attr.id]="'corte-interamericana-de-derechos-humanos'">
      <h3 class="tab-manual__content--bl-subtitle">Corte Interamericana de Derechos Humanos</h3>
      <p>Para realizar búsquedas especializadas de información emitidas por uno de los tres
        tribunales regionales de protección de los derechos humanos, se da clic en la Corte
        Interamericana de Derechos Humanos.</p>
      <p>En esta fuente de información se cuentan con diversos criterios que permiten
        realizar búsquedas específicas:</p>
      <ul class="ml-5">
        <li> Origen</li>
        <li> País</li>
        <li> Año</li>
        <li> Temas relevantes</li>
      </ul>
      <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
        <div class="col-12">
          <img class="w-100 imgborde" src="./assets/img/img-manual/UGACJ_Imagen_MBJ_65p.png"
            alt="Contenido tratados internacionales de derechos humanos">
        </div>
      </div>
    </div>
    <!--
    <div class="tab-manual__content--bl" [attr.id]="'tesauro'">
      <h2 class="tab-manual__content--bl-title skin-color-text">Tesauro</h2>
      <p>En la página principal se visualiza el ícono para acceder a la plataforma Tesauro, el
        vocabulario controlado de términos para el análisis temático de la Suprema Corte
        de Justicia de la Nación, con la finalidad de coadyuvar a quienes trabajan en la labor
        jurisdiccional y de investigación, así como a todos los interesados en conocer un
        lenguaje jurídico de referencia.</p>

      <p>El Tesauro es un vocabulario estructurado y dinámico en el cual los conceptos están
        representados por términos organizados del tal modo que las relaciones entre ellos
        son explicitadas y los términos preferentes están acompañados por sus sinónimos
        o cuasi-sinónimos. Se trata de un instrumento de normalización y control de
        vocabulario cuyo objetivo reside en eliminar la ambigüedad del lenguaje,
        convirtiendo el lenguaje natural de los documentos en un lenguaje controlado.</p>

      <p>Para acceder es necesario dar clic sobre el ícono “Tesauro” que se encuentra en la
        página de inicio del Buscador Jurídico.</p>
      <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
        <div class="col-12">
          <img class="w-100 imgborde" src="./assets/img/img-manual/UGAC_Imagen_MBJ_97.png" alt="Tesauro">
        </div>
      </div>

      <p>En la plataforma del Tesauro se muestran una serie de opciones.</p>
      <ul class="ml-5">
        <li>Botón de “home” para regresar a la página de inicio</li>
        <li>Barra de búsqueda</li>
        <li>Búsqueda avanzada</li>
        <li>Grafo semántico</li>
        <li>Acerca del vocabulario</li>
        <li>Botón de “ayuda” para acceder a la guía de uso</li>
        <li>Navegación alfabética</li>
        <li>Navegación sistemática</li>
      </ul>

      <div class="d-flex p-2 psm-3 plg-3 pxl-5 pmd-3">
        <div class="col-12">
          <img class="w-100 imgborde" src="./assets/img/img-manual/UGAC_Imagen_MBJ_98p.png" alt="Contenido tesauro">
        </div>
      </div>
    </div>
    -->
    <div class="tab-manual__content--bl" [attr.id]="'recomendación'">
      <h2 class="tab-manual__content--bl-title skin-color-text">Recomendación</h2>
      <p>Para el mejor aprovechamiento del Buscador Jurídico, y en virtud de su permanente
        evolución, se recomienda hacer un análisis exploratorio para identificar más
        características innovadoras, técnicas y de diseño, así como de integración de otros
        universos de información.</p>

      <p>El uso y la navegación constante en el Buscador Jurídico le permitirá adquirir mayor
        agilidad al momento de realizar búsquedas.</p>
    </div>
    <div class="tab-manual__content--bl" [attr.id]="'material'">
      <h2 class="tab-manual__content--bl-title skin-color-text">Material para presentación</h2>
      <div class="tab-manual__content--bl" [attr.id]="'generales'">
        <h3>Generales</h3>
        <p>Ejemplos de búsqueda haciendo uso de la sintaxis empleada en el BJ:</p>
        <div class="p-2" id="gralex">
          <h4>Búsqueda por palabras clave</h4>
          <div class="d-flex flex-column">
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="libre desarrollo personalidad"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>libre desarrollo personalidad</div>
            </div>
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="guarda custodia"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>guarda custodia</div>
            </div>
          </div>
          <h4>Búsqueda por frase exacta</h4>
          <div class="d-flex flex-column">
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="'patria potestad'"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>"patria potestad"</div>
            </div>
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="'matrimonio de menores'"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>"matrimonio de menores"</div>
            </div>
          </div>
          <h4>Búsqueda con frase exacta para Corte Europea</h4>
          <div class="d-flex flex-column">
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="'interés superior'"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>"interés superior"</div>
            </div>
          </div>
          <h4>Búsquedas con operador lógico AND</h4>
          <div class="d-flex flex-column">
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom"
                  data-copy="'interés superior de la niñez' AND 'desarrollo personal'"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i>
              </div>
              <div>"interés superior de la niñez" AND "desarrollo personal"</div>
            </div>
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom"
                  data-copy="'doble nacionalidad' AND (privilegios)"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i>
              </div>
              <div>"doble nacionalidad" AND (privilegios)</div>
            </div>
          </div>
          <h4>Búsquedas con operador lógico OR</h4>
          <div class="d-flex flex-column">
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="estupro OR 'abuso sexual a menores'"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i>
              </div>
              <div>estupro OR "abuso sexual a menores"</div>
            </div>
          </div>
          <h4>Búsquedas con operador lógico NOT y - </h4>
          <div class="d-flex flex-column">
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom"
                  data-copy="'doble nacionalidad' NOT (internacional)"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i>
              </div>
              <div>"doble nacionalidad" NOT (internacional)</div>
            </div>
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="'doble nacionalidad' -internacional"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i>
              </div>
              <div>"doble nacionalidad" -internacional</div>
            </div>
          </div>
          <h4>Búsqueda combinando Operadores y Sintaxis</h4>
          <div class="d-flex flex-column">
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom"
                  data-copy="('desaparición forzada' OR secuestro )AND 'delincuencia organizada'"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>("desaparición forzada" OR secuestro )AND "delincuencia organizada"</div>
            </div>
          </div>
          <h4>Búsquedas con el uso del caracter &#64; </h4>
          <div class="d-flex flex-column">
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="'juicio sucesorio'"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>Sentencias: &#64;Considerando= "juicio sucesorio"</div>
            </div>
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="'juicio sucesorio'"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>O en los campos(resultados) "juicio sucesorio"</div>
            </div>
          </div>
          <h4>Búsquedas con asterísco (*)</h4>
          <div class="d-flex flex-column">
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="*echo"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i>
              </div>
              <div>*echo</div>
            </div>
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="pr*tos"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i>
              </div>
              <div>pr*tos</div>
            </div>
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="trabaja*"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i>
              </div>
              <div>trabaja*</div>
            </div>
          </div>
          <h4>Búsqueda con virgulilla (~) para encontrar palabras similares</h4>
          <div class="d-flex flex-column">
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="mubying~"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i>
              </div>
              <div>mubying~</div>
            </div>
          </div>
          <h4>Búsqueda avanzada</h4>
          <div class="d-flex flex-column">
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="reviviscencia"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>reviviscencia</div>
            </div>
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="sistema normativo"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>sistema normativo</div>
            </div>
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="emancipación"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>emancipación</div>
            </div>
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="acceso a la justicia"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>acceso a la justicia</div>
            </div>
            <div class="col-12">
              <strong>&nbsp;&nbsp;&nbsp;--- Búsquedas indicando proximidad entre palabras></strong>
            </div>
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="sucesión intestamentaria alicuota"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>"sucesión intestamentaria alicuota"~20</div>
            </div>
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="interdicción arbitrariedad menor"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>"interdicción arbitrariedad menor"~10</div>
            </div>
          </div>
        </div>
      </div>
      <div class="tab-manual__content--bl" [attr.id]="'agraria'">
        <h3>Materia Agraria</h3>
        <p>Ejemplos de búsqueda haciendo uso de la sintaxis empleada en el BJ:</p>
        <div class="p-2" id="gralagra">
          <h4>Búsqueda por palabras clave</h4>
          <div class="d-flex flex-column">
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="subsidio ejidal"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>subsidio ejidal</div>
            </div>
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="subvención ejidal"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>subvención ejidal</div>
            </div>
          </div>
          <h4>Búsqueda por frase exacta</h4>
          <div class="d-flex flex-column">
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="'usufructo parcelario'"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>"usufructo parcelario"</div>
            </div>
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="'acción reivindicatoria'"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>"acción reivindicatoria"</div>
            </div>
          </div>
          <h4>Uso de paréntesis para priorizar sobre una búsqueda"</h4>
          <div class="d-flex flex-column">
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="impuesto predial (ejidal)"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>impuesto predial (ejidal)</div>
            </div>
          </div>
          <h4>Búsquedas con operador lógico AND</h4>
          <div class="d-flex flex-column">
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="'tierras agrícolas' AND cultivo"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i>
              </div>
              <div>"tierras agrícolas" AND cultivo</div>
            </div>
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="agostadero AND reproducción"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>agostadero AND reproducción</div>
            </div>
          </div>
          <h4>Búsquedas con operador lógico OR</h4>
          <div class="d-flex flex-column">
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom"
                  data-copy="tierra (agrícolas OR ganadera OR forestales)"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>tierra (agrícolas OR ganadera OR forestales)</div>
            </div>
          </div>
          <h4>Búsquedas con operador lógico NOT y - </h4>
          <div class="d-flex flex-column">
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="'terreno baldío' NOT abandonado"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>"terreno baldío" NOT abandonado</div>
            </div>
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="'terreno baldío' -abandonado"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>"terreno baldío" -abandonado</div>
            </div>
          </div>
          <h4>Búsqueda combinando Operadores y Sintaxis</h4>
          <div class="d-flex flex-column">
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom"
                  data-copy="('tierras para asentamiento humano' OR 'tierras de uso común') AND parcelada"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>("tierras para asentamiento humano" OR "tierras de uso común") AND parcelada
              </div>
            </div>
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom"
                  data-copy="enajenación AND prelación  NOT despojo"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i>
              </div>
              <div>enajenación AND prelación NOT despojo</div>
            </div>
          </div>
          <h4>Búsquedas con el uso del caracter &#64; </h4>
          <div class="d-flex flex-column">
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="'Ley Agraria'"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>Ordenamientos: &#64;Nombre ordenamiento: "Ley Agraria" &#64;Artículo: 44</div>
            </div>
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="'Ley Agraria'"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>O en los campos(resultados) "Ley Agraria"</div>
            </div>
          </div>
          <h4>Búsquedas con asterísco (*)</h4>
          <div class="d-flex flex-column">
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="eji*"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i>
              </div>
              <div>eji*</div>
            </div>
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="traba*"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i>
              </div>
              <div>traba*</div>
            </div>
          </div>
          <h4>Búsqueda con virgulilla (~) para encontrar palabras similares</h4>
          <div class="d-flex flex-column">
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="enajenar~"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i>
              </div>
              <div>enajenar~</div>
            </div>
          </div>
          <h4>Búsqueda avanzada</h4>
          <div class="d-flex flex-column">
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="ejidales"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>ejidales</div>
            </div>
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="sociedades mercantiles"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>sociedades mercantiles</div>
            </div>
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="emancipación"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>parcela</div>
            </div>
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="lindero"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>lindero (como palabra que debe contener)</div>
            </div>
            <div class="col-12">
              <strong>&nbsp;&nbsp;&nbsp;--- Búsquedas indicando proximidad entre palabras></strong>
            </div>
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="población ejidataria sucesión"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>"población ejidataria sucesión"~20</div>
            </div>
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="núcleo población ejido"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>"núcleo población ejido"~10</div>
            </div>
          </div>
        </div>
      </div>
      <div class="tab-manual__content--bl" [attr.id]="'mercantil'">
        <h3>Competencia económica</h3>
        <p>Ejemplos de búsqueda haciendo uso de la sintaxis empleada en el BJ:</p>
        <div class="p-2" id="gralmer">
          <h4>Búsqueda por palabras clave</h4>
          <div class="d-flex flex-column">
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="Monopolio"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>Monopolio</div>
            </div>
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="crédito habilitación avío"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>crédito habilitación avío</div>
            </div>
          </div>
          <h4>Búsqueda por frase exacta</h4>
          <div class="d-flex flex-column">
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="'comercio exterior'"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>"comercio exterior"</div>
            </div>
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="'certificado de origen'"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>"certificado de origen"</div>
            </div>
          </div>
          <h4>Uso de paréntesis para priorizar sobre una búsqueda"</h4>
          <div class="d-flex flex-column">
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="productos mercancía(acopio)"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>productos mercancía(acopio)</div>
            </div>
          </div>
          <h4>Búsquedas con operador lógico AND</h4>
          <div class="d-flex flex-column">
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="franquicia AND 'derecho de propiedad'"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i>
              </div>
              <div>franquicia AND "derecho de propiedad"</div>
            </div>
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom"
                  data-copy="'Prácticas monopólicas absolutas' AND 'Prácticas monopólicas relativas'"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>"Prácticas monopólicas absolutas" AND "Prácticas monopólicas relativas"</div>
            </div>
          </div>
          <h4>Búsquedas con operador lógico OR</h4>
          <div class="d-flex flex-column">
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="'mercado organizado' OR bróker"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>"mercado organizado" OR bróker</div>
            </div>
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="subvención OR subsidio"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>subvención OR subsidio</div>
            </div>
          </div>
          <h4>Búsquedas con operador lógico NOT y - </h4>
          <div class="d-flex flex-column">
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="'libre competencia' NOT económica"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>"libre competencia" NOT económica</div>
            </div>
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="'libre competencia' -económica"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>"libre competencia" -económica</div>
            </div>
          </div>
          <h4>Búsqueda combinando Operadores y Sintaxis </h4>
          <div class="d-flex flex-column">
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom"
                  data-copy="('Inscripción de licencia de uso' OR franquicia) AND 'registro de marca'"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>("Inscripción de licencia de uso" OR franquicia) AND "registro de marca"</div>
            </div>
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom"
                  data-copy="'balanza comercial' OR 'balanza de pagos' AND (mercado)"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i>
              </div>
              <div>"balanza comercial" OR "balanza de pagos" AND (mercado)</div>
            </div>
          </div>
          <h4>Búsquedas con el uso del caracter &#64; </h4>
          <div class="d-flex flex-column">
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="'actividad comercial'"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>Sentencias: &#64;Considerando: "actividad comercial"</div>
            </div>
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="'actividad comercial'"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>O en los campos(resultados) "actividad comercial"</div>
            </div>
          </div>
          <h4>Búsquedas con asterísco (*)</h4>
          <div class="d-flex flex-column">
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="monopo*"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i>
              </div>
              <div>monopo*</div>
            </div>
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="comer*"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i>
              </div>
              <div>comer*</div>
            </div>
          </div>
          <h4>Búsqueda con virgulilla (~) para encontrar palabras similares</h4>
          <div class="d-flex flex-column">
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="holding~"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i>
              </div>
              <div>holding~</div>
            </div>
          </div>
          <h4>Búsqueda avanzada</h4>
          <div class="d-flex flex-column">
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="importaciones"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>importaciones</div>
            </div>
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="investigación antidumping"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>investigación antidumping</div>
            </div>
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="INCOTERMS"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>INCOTERMS</div>
            </div>
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="comercio internacional"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>comercio internacional</div>
            </div>
            <div class="col-12">
              <strong>&nbsp;&nbsp;&nbsp;--- Búsquedas indicando proximidad entre palabras></strong>
            </div>
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="certificado embarque importacion"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>"certificado embarque importacion" ~20</div>
            </div>
            <div class="d-flex flex-row align-items-center">
              <div><i ngbTooltip="Clic para copiar" placement="bottom" data-copy="impuesto ad valorem"
                  class="mr-2 fa fa-copy copy-btn components-bg--a3"></i></div>
              <div>"impuesto ad valorem" ~10</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
